export const MOT_HISTORY_TITLE_TEXT = 'MOT History -';
export const MOT_HISTORY_PASS_TEXT = 'MOT PASS';
export const MOT_HISTORY_FAIL_TEXT = 'MOT FAIL';
